import { useQuery } from '@tanstack/react-query';

import * as LoyaltyService from '~/services/LoyaltyService';

import { pointsPurchaseQueryKeys } from './pointsPurchaseQueryKeys';

export function useGetPointsPurchaseOffersPreview(currency: string, enabled: boolean) {
  return useQuery({
    queryKey: pointsPurchaseQueryKeys.offersPreview(currency),
    queryFn: async ({ signal }) => LoyaltyService.listPointsPurchaseOffers(currency, { signal }),
    enabled,
  });
}
